import { UtilityService } from "./index";

class NewDashboardServices {

  async activeCountNewDashboard() {
    let result = await fetch(
      UtilityService.baseUrl() + "api/customer/active-count",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        }
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async activeDepartmentsNewDashboard() {
    let result = await fetch(
      UtilityService.baseUrl() + "api/customer/deprtment-cout",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        }
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async activeEmployeesNewDashboard() {
    let result = await fetch(
      UtilityService.baseUrl() + "api/customer/empoyee-cout",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        }
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async fabricCountNewDashboard() {
    let result = await fetch(
      UtilityService.baseUrl() + "api/customer/fabric-cout",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        }
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async bNumberCountNewDashboard() {
    let result = await fetch(
      UtilityService.baseUrl() + "api/customer/bnumber-cout",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        }
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async sampleRequestCountNewDashboard() {
    let result = await fetch(
      UtilityService.baseUrl() + "api/customer/samplerequest-cout",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        }
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async completedSampleRequestCountNewDashboard() {
    let result = await fetch(
      UtilityService.baseUrl() + "api/customer/sample-cout",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        }
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

}
export default new NewDashboardServices();



// WEBPACK FOOTER //
// ./src/services/newdashboard.service.js